import axiosInstance from '@/store/axios'
import { rejectErrorApi } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    overview ({ commit }) {
      return axiosInstance.get('/api/v1/overview')
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    scheduleLoading ({ commit }, query) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/schedule-loading',
        data: query,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
    // eslint-disable-next-line no-unused-vars
    assetDistributionByRules ({ commit }, params) {
      return axiosInstance.get('/api/v1/asset-distrib-by-rules', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectErrorApi(error))
    },
  },
}
